<template>
  <div>   
    <v-card
      flat
      class="px-2 mt-3 mx-1"  
    >
      <v-row 
        class="mx-1"
      >
        <v-col
          cols="12"
          sm="6"  
        >
          <v-btn-toggle
            v-if="firstTab.userReward!==undefined"
            v-model="selectType"
            multiple
            class="d-flex "
            borderless
            dense
            color="green"
          >
            <v-btn
              :value="1"
              depressed
              block
              @click="changeStatus(firstTab.number_type.id,firstTab.number_type.name)"
            >
              <v-icon>mdi-check</v-icon><h5>{{ firstTab.number_type.name }} ({{ firstTab.userReward | currency }})</h5>
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col
          cols="12"
          sm="6"  
        >
          <v-btn-toggle
            v-if="!secondTab.Is_empty&&secondTab.userReward!==undefined"
            v-model="selectType"
            class="d-flex"
            multiple
            borderless
            dense
            color="green"
          >
            <v-btn
              :value="2"
              depressed
              block
              @click="changeStatus(secondTab.number_type.id,secondTab.number_type.name)"
            >
              <v-icon>mdi-check</v-icon><h5>{{ secondTab.number_type.name }} ({{ secondTab.userReward | currency }})</h5>
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-spacer />
      </v-row>
    </v-card>
    <div :class="!(firstTab.status||(!secondTab.Is_empty&&secondTab.status)) ? 'diable-all' :''">
      <v-row no-gutters>
        <v-col
          class="px-1"
          cols="12"
          md="7"
        >
          <v-row no-gutters>
            <v-card
              flat
              class="mt-3 pa-3 d-flex justify-center"
              width="100%"
            >  
              <v-row 
                no-gutters
                class="my-1" 
              >
                <v-col  
                  v-for="(item,i) in selectAmountList"
                  :key="i"  
                  class="column-five "
                >
                  <v-btn-toggle
                    v-model="selectAmount" 
                    color="var(--bg-secondary-color)" 
                    class="d-block ma-1"
                    multiple 
                    borderless
                  > 
                    <v-btn  
                      class="notranslate force-round"
                      block 
                      :value="item.value"
                      :color="checkLimitCondition(item)" 
                      :disabled="checkDisable(item)"
                      @click="addValue(item)" 
                    >
                      <h3>{{ checkDisable(item) ? $t('button.out-of-stock') : item.number }}</h3> 
                    </v-btn> 
                  </v-btn-toggle>
                </v-col>
              </v-row> 
            </v-card>
          </v-row>
          <v-row no-gutters>
            <limitlistcard 
              :first-tab="firstTab" 
              :first-tab-status="firstTab.status" 
              :second-tab="secondTab" 
              :second-tab-status="secondTab.status" 
            /> 
          </v-row>
        </v-col>
        <v-col
          class="px-1"
          cols="12"
          md="5"
        >
          <v-card
            flat
            class="text-center py-3 mt-3"
          >
            <h4>{{ $t('enter-number') }}</h4>
            <v-row
              no-gutters
              class="mx-3"
            >
              <v-col>
                <n-number-field-specific
                  v-model="digitNumber" 
                  readonly 
                />
              </v-col>
            </v-row>
            <numPad
              :method-digit="addDigit"
              :is-disable="!(firstTab.status||(!secondTab.Is_empty&&secondTab.status))"
              @removeLastNumber="removeLastNumber"
              @clearAll="clearAll"
              @removeDigit="removeDigit"
            />
          </v-card>
          <slot />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import numPad from './NumPad'  
import limitlistcard from './LimitList' 
import * as c from '@/const/setTimeOutConfig' 
export default {
  components:{
    numPad, 
    limitlistcard
  }, 
  props : {
    switchToggle : {
      type:Boolean,
      default:false
    },
 
    indexSelect : { 
      type:Number,
      default:0
    },

    firstTab : {
      type:[Object,Boolean],
      default:()=>{
        return {
          limit_conditions : []
        }
      }
    },
    secondTab: {
      type:[Object,Boolean],
      default:()=>{
        return {
          status:false,
          Is_empty:true,
          limit_conditions : []
        }
      }
    },
    userSelect:{
      type:Array,
      default:()=>{
        return[]
      }
    },
    filterNumber:{
      type:String,
      default:()=>''
    },   
    voucher:{
      type:Object,
      default:()=>{}
    }, 
  },
  data () {
    return { 
      selectAmount:[],  
      digitNumber:'',  
      selectType : [],
      selectAmountBase:[],
      LIMITL : 2, 
      ALMOST : 1, 
      NORMAL : 0
    }
  },    
  computed : {
    selectAmountList () { 
      return  this.filterNumber ? 
              this.selectAmountBase
              .filter(x=>x.number
              .includes(this.filterNumber)) : 
              this.selectAmountBase
    }
  },
  watch:{    
    indexSelect () { 
      this.initLimitCondition()
      this.checkStatusActive()
    },
    userSelect () {
      this.checkStatusActive()
    },
    digitNumber (){ 
      var item = this.selectAmountBase.find(x=>x.number===this.digitNumber.toString())  
      setTimeout( () => {
        if(item && !this.selectAmount.includes(item.value) && this.digitNumber.length!==0){
          setTimeout(()=>{ 
          this.addValue(item)
          this.selectAmount.push(item.value)
          this.digitNumber='',c.COUNTDOWNONESEC })
        }
        else if(item && this.digitNumber.length!==0){
          this.$noty.error(this.$t('already-select-number',{number:item.value}))
          this.digitNumber=''
        }
      }
      ,c.DELAYDIGITALPIN) 
    }, 
  },
  async created () {  
    this.checkStatusActive()
    this.initLimitCondition()
  },
  methods :{ 
    initLimitCondition () {   
      this.selectAmountBase = Array.from(Array(10).keys()).map(x=>{
        let result = {
          value : x,
          number : this.changeNumbertoString(x),
          first : this.NORMAL,
          second : this.NORMAL,
          userReward_first : 0,
          userReward_second : 0
        } 
        
        let firstLimitFind = (this.firstTab.limit_conditions || []).filter(x=>x.number===result.number) 
        let secondLimitFind = (this.secondTab.limit_conditions || []).filter(x=>x.number===result.number) 
 
        if(firstLimitFind.length !==0){   
          let reward = Math.min.apply(Math,firstLimitFind.map(x=>x.quota_reward))  
          result.first = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward_first =  reward
        }
        if(secondLimitFind.length !==0){  
          let reward = Math.min.apply(Math,secondLimitFind.map(x=>x.quota_reward))  
          result.second = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward_second = reward
        }
        return result
      })   
    },   
    
    checkDisable (item) {
      let check = this.secondTab.status ? item.second : this.firstTab.status ? item.first : null
      if(this.secondTab.status && this.firstTab.status) {
        check = Math.max(item.first,item.second)
      }
      return check === this.LIMITL ? true : false
    },

    checkLimitCondition (item) { 
      let check = this.secondTab.status ? item.second : this.firstTab.status ? item.first : null
      if(this.secondTab.status && this.firstTab.status) {
        check = Math.max(item.first,item.second)
      }
      switch(check){
        case this.NORMAL:
          return ''
        case this.ALMOST:
          return 'red'
        case this.LIMITL:
          return 'red'
          
      }
      return '' 
    }, 
    removeDigit () {
      this.digitNumber=""
    },

    changeStatus (id,name) {
      this.$ga.event('Button', 'ToggleSelectType', 'OneDigitPage', name)
      this.$emit('changeStatus',id)
      this.checkStatusActive ()
    },

    checkStatusActive () {  
      this.resetBoardDisplay() 
      this.selectType = this.firstTab.status&&this.secondTab.status 
      ? [1,2] 
      : this.firstTab.status ? [1] 
      : this.secondTab.status ? [2] 
      : []
      this.userSelect.forEach(element => {
        if((element.number_type_id===this.firstTab.number_type.id && this.firstTab.status) ||
        (element.number_type_id===this.secondTab.number_type.id && this.secondTab.status)) {
          this.selectAmount.push(parseInt(element.number)) 
        }
      }); 
    },    

    resetBoardDisplay () {
      this.selectAmount = []  
      this.selectType = []
    }, 

    clearAll (){ 
      this.$emit('clearAll') 
    },

    addDigit (number) {
      this.digitNumber = number
    },

    removeLastNumber (){  
      this.$emit('removeLastNumber')
    }, 

    changeNumbertoString (value){    
      return value<10 ? value.toString() : '' 
    },

    addValue (item){   
      var changeNumbertoString = item.number
      this.$ga.event('Button', 'Add&DeleteValue', 'OneDigitPage', changeNumbertoString) 
      var status = this.selectAmount.includes(item.value)
      var actionStatus = status ? 'delValue': 'addValue'  
      
      let Bypass = false 
      let stakeMaxNumber = (this.voucher.rules || {}).stake_max_number
      let checkVoucherStake = this.voucher.rules && stakeMaxNumber

      if( checkVoucherStake &&
        this.userSelect.length >= parseInt(stakeMaxNumber) &&
        actionStatus === 'addValue'
      ){ 
        if(!Bypass) {  
          this.$nextTick(()=>{
            this.checkStatusActive() 
          }) 
        }
        
        Bypass = true
        return
      } 

      if(this.firstTab.status && item.first !== this.LIMITL){ 
        let price = item.first === this.NORMAL ? this.firstTab.userReward : item.userReward_first
        this.$emit(actionStatus,price,changeNumbertoString,this.firstTab.number_type.id,null,null,null)
      }
      if(this.secondTab.status && item.second !== this.LIMITL) {
        let price = item.second === this.NORMAL ? this.secondTab.userReward : item.userReward_second
        this.$emit(actionStatus,price,changeNumbertoString,this.secondTab.number_type.id,null,null,null)
      }   
    }, 
  }
}
</script>  